export class CloneInterest {
  static readonly type = '[Contract.Interest] Clone Interest';
  constructor(public interestID: number, public copies: number = 1) {}
}

export class DeleteInterest {
  static readonly type = '[Contract.Interest] Delete Interest';
  constructor(public interestID: number) {}
}

export class RestoreInterest {
  static readonly type = '[Contract.Interest] Restore Interest';
  constructor(public interestID: number) {}
}

export class AddInterest {
  static readonly type = '[Contract.Interest] Add Interest';
  constructor(public thirdParty: any, public interest: any, public ref: any = { Ref_Type: 'Contract' }) {}
}

export class UpdateInterest {
  static readonly type = '[Contract.Interest] Update Interest';
  constructor(public interest: any) {}
}

export class AddEntityInterestLink {
  static readonly type = '[Contract.Interest] Add Entity Interest Link';
  constructor(public entityID: string, public interestID: string) {}
}

export class RemoveEntityInterestLink {
  static readonly type = '[Contract.Interest] Remove Entity Interest Link';
  constructor(public entityID: string, public interestID: string) {}
}
